// extracted by mini-css-extract-plugin
export var avatar = "Header-module--avatar--owuZy";
export var line = "Header-module--line--xopFn";